import GlobalTrackingPixels from './GlobalTrackingPixels';

export default GlobalTrackingPixels;
